<template>
  <v-data-table
    :headers="headers"
    :items="trackList"
    hide-actions
    class="elevation-1">
    <template
      slot="items"
      slot-scope="props">
      <td>{{ formatDate(props.item.start_time) }}</td>
      <td>{{ formatDate(props.item.stop_time) }}</td>
      <td>{{ duration(props.item.durationInSeconds) }} {{ $t('h') }}</td>
    </template>
  </v-data-table>
</template>
<script>
export default {
  name: 'TimetrackingTable',
  props: ['trackList'],
  data () {
    return {
      headers: [
        { text: this.$t('startTime'), sortable: false, align: 'left' },
        { text: this.$t('stopTime'), sortable: false, align: 'left' },
        { text: this.$t('duration'), sortable: false, alight: 'right' }
      ]
    }
  },
  methods: {
    formatDate (date) {
      return this.$moment(date, 'YYYY-MM-DD HH:mm:ss')
        .format('DD.MM.YYYY HH:mm')
    },
    duration (seconds) {
      return this.$moment()
        .hour(0)
        .minute(0)
        .second(seconds)
        .format('HH:mm')
    }
  },
  i18n: {
    messages: {
      en: {
        duration: 'Duration',
        h: 'Hours',
        startTime: 'Started',
        stopTime: 'Stopped'
      },
      tr: {
        duration: 'Süre',
        h: 'Saat',
        startTime: 'Başlatıldı',
        stopTime: 'Durduruldu'
      },
      de: {
        duration: 'Dauer',
        h: 'Stunden',
        startTime: 'Gestartet',
        stopTime: 'Gestoppt'
      },
      ru: {
        duration: 'Продолжительность',
        h: 'Часов',
        startTime: 'Начать',
        stopTime: 'Остановить'
      }
    }
  }
}
</script>
<style>
</style>
